import React from 'react';
import PropTypes from 'prop-types';
import staticPath from 'util/misc/static-assets-path';
import classnames from 'classnames';

const ErrorImageEmpty = ({ className, alt }) => {
    return <img src={staticPath('img/error/im-empty.png')} alt={alt} className={classnames('error-empty', className)} />;
};

ErrorImageEmpty.propTypes = {
    className: PropTypes.string,
    alt: PropTypes.any,
};

export default ErrorImageEmpty;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/error-image/empty/index.js